module.exports = __webpack_public_path__ + "static/media/card-american-express.bcb81e8b.svg";